import React, {useEffect, useState} from 'react'
import Modal from "../widget/Modal";
import {useTranslation} from "react-i18next";
import useBlocker from "../../hooks/router/useBlocker";
import handleOnUnloadEvent from "../../hooks/router/handleOnUnloadEvent";
import PropTypes from "prop-types";

const FormContainer = (props) => {

  const {t} = useTranslation();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);

  useEffect(() => {
    window.addEventListener('beforeunload', handleOnUnloadEvent)

    return () => window.removeEventListener('beforeunload', handleOnUnloadEvent)
  }, [])

  const stayOnPage = () => {
    setShowConfirmDialog(false);
  }

  const leavePage = () => {
    window.removeEventListener('beforeunload', handleOnUnloadEvent)
    setShowConfirmDialog(false);
    window.location.href = nextLocation;
  }

  useBlocker((redirect) => {
    setNextLocation(redirect.pathname);
    setShowConfirmDialog(true);
  }, props.isEdited())

  return (
    <div>
      <form onSubmit={props.onSubmit}>
        {props.children}
      </form>
      <Modal title={t('leave_page_title')}
             content={t('leave_page_question')}
             showPopup={showConfirmDialog}
             label={t('leave')}
             onClose={() => stayOnPage()}
             onDelete={() => leavePage()}>
      </Modal>
    </div>

  )

}

FormContainer.propTypes = {
  isEdited: PropTypes.func,
  onSubmit: PropTypes.func
}

export default FormContainer
